import React, {Component} from "react";
import Table from "../../components/Table";
import ProductWaitingListItem from "./ProductWaitingListItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import gql from "graphql-tag";

class ProductWaitingList extends Component {

  render() {
    let {loading, error, productWaitingList} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Shop",
      "Name",
      "Email",
      "SKU",
      "Kind",
      "Subscribed At",
    ])          
    return (
      <Table 
        data={fromJS(productWaitingList)} 
        renderer={ProductWaitingListItem} 
        onItemClick={this.handleItemClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="ProductWaitingList"
        itemKey="id"
        mode="table"
        selected={this.props.selectedId}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    this.props.onSelectionChange(itemData);
  }  
}

const WAITING_LIST = gql`
  query productWaitingList($filter: ProductWaitingListFilter) {
    productWaitingList(filter: $filter) {
      id
      customerId
      shopId
      sku
      kind
      createdAt
      customer {
        name
        email
      }
    }
  }
`;

const withQuery = graphql(WAITING_LIST, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        shopId: props.shopFilter,
        kind: props.kindFilter,
        sku: props.skuFilter
      }
    }
  })
})

export default withQuery(ProductWaitingList);